import http from '../services/httpServiceHealthCare'

const API_URL = '/KnowledgeVideos'

export const getVideos = async () => {
    const response = await http.get(API_URL)
    return response
}

export const getVideo = async (id) => {
    const response = await http.get(`${API_URL}/${id}`)
    return response
}

export const createVideo = async (data) => {
    const response = await http.post(API_URL, data)
    return response
}

export const updateVideo = async (id, data) => {
    const response = await http.patch(`${API_URL}/${id}`, data)
    return response
}

export const deleteVideo = async (id) => {
    const response = await http.delete(`${API_URL}/${id}`)
    return response
}

